/* eslint-disable */
import React, { PropTypes } from 'react';
import _ from 'lodash';
import $ from 'jquery';
import { Modal, Button, Col, Row, Well } from 'react-bootstrap';
import { TextField, ReadOnlyField } from './AdminComponents';
import { ChromePicker } from 'react-color';
import { browserHistory } from 'react-router';
import getObjByCategory from '../../../commonJS/getObjByCategory';
import Select from 'react-select';

export default class AdminCt extends React.Component {
  constructor(props) {

    super(props);

    this.state = {
      enableEdit: false,
      showErrorMsg: false,
      name_value: '',
      color_value: '#FF0000',
      category: getObjByCategory(props.category),
      fileproperty_data: [],
      fileproperty_id: '',
      fileproperty_option: ''
    }

    this.onChangeHandler = this.onChangeHandler.bind(this)
    this.onChangeFilePropertyValue = this.onChangeFilePropertyValue.bind(this)
  }

  componentDidMount() {

    const { type } = this.props.route
    const { category } = this.state

    if (category.name === 'FilePropertyValue') {

      this.loadFilePropertyData()
    }

    type === 'add' ? this.setState({ enableEdit: true }) : this.loadOneData()
  }

  componentDidUpdate() {

    const { category, fileproperty_option, fileproperty_id, fileproperty_data } = this.state

    if (category.name === 'FilePropertyValue' && fileproperty_option === '' && fileproperty_id !== '' && fileproperty_data.length !== 0) {

      let select_option = _.find(fileproperty_data, { value: fileproperty_id })
      this.setState({ fileproperty_option: select_option });
    }
  }

  loadOneData() {

    const { id } = this.props.params
    const { category } = this.state

    $.ajax({
      type: 'get',
      url: category.get_url + '?id=' + id,
      success: response => {
        this.setState({ name_value: response.result[0].name })

        switch (category.name) {
          case 'UserGroup':
            this.setState({ color_value: response.result[0].color_code });
            break;
          case 'FilePropertyValue':
            this.setState({ fileproperty_id: response.result[0].fileproperty_id });
            break;
          default:
            break;
        }
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    });
  }

  loadFilePropertyData() {

    $.ajax({
      type: 'get',
      url: '/api/W_FileProperty_Get.php',
      success: response => {
        let fileproperty_data = response.result.map((x, y) => {
          return { value: x.id, label: x.name }
        })

        this.setState({ fileproperty_data: fileproperty_data });
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    });
  }

  onSubmit() {

    const { params, route } = this.props
    const { name_value, color_value, category, fileproperty_option } = this.state

    if (name_value === '') {

      this.setState({ showErrorMsg: true })
    }
    else {

      let formData = new FormData();
      formData.append('name', name_value);        //群組名稱

      if (route.type === 'edit') {
        formData.append('id', params.id)
      }

      switch (category.name) {

        case 'UserGroup':
          formData.append('color_code', color_value); //色碼
          break;
        case 'FilePropertyValue':
          formData.append('fileproperty_id', fileproperty_option.value); //檔案屬性名稱id
          break;
        default:
          break;
      }

      for (var value of formData.values()) { }

      $.ajax({
        type: 'post',
        url: route.type === 'add' ? category.post_url : category.update_url,
        data: formData,
        processData: false,
        contentType: false,
        success: response => {
          if (response.status === '0') {//成功

            this.setState({ enableEdit: false })
            this.props.loadData();
            browserHistory.push('/salesky/admin/' + category.name + '/' + response.result[0].id);
          }
          else {
            alert(response.msg);
          }
        },
        error: error => { },
        // complete: ()=> {
        //     this.loadOneNews();//重刷頁面
        //     this.props.reloadDataList();//newsDataTable也要重刷頁面
        // },
      });
    }
  }

  onChangeHandler(stateName, event) {
    // stateName: 要修改的state

    let newState = {};
    newState[stateName] = event.target.value;
    this.setState(newState);
  }

  handleChangeColor = (color) => {

    this.setState({ color_value: color.hex });
  }

  onRemove() {

    const { closeModal, params } = this.props
    const { category } = this.state

    let formData = new FormData();
    formData.append('id', params.id);

    if (confirm('確定刪除嗎?')) {

      $.ajax({
        type: 'post',
        url: category.remove_url,
        data: formData,
        processData: false,
        contentType: false,
        success: response => {
          if (response.status === '0') {//成功
            // this.setState({ enableEdit: false })
            this.props.loadData();
            closeModal()
          }
          else {
            alert(response.msg);
          }
        },
        error: error => { },
      });
    }
  }

  onChangeFilePropertyValue(options) {

    this.setState({ fileproperty_option: options })
  }

  renderBtns() {

    const { closeModal, route } = this.props
    const { enableEdit, category } = this.state

    let remove_btn = (route.type === 'edit' && enableEdit === true && category.name !== 'FileProperty') ? <Button onClick={() => this.onRemove()}>刪除</Button> : null
    let edit_btn = enableEdit === true ? <Button onClick={() => this.onSubmit()}>儲存</Button> : <Button onClick={() => this.setState({ enableEdit: true })}>編輯</Button>

    return (
      <div>
        {remove_btn}
        {edit_btn}
        <Button onClick={closeModal}>關閉</Button>
      </div>
    )
  }

  renderColorCodeColumn() {

    const { color_value, enableEdit, category } = this.state

    return (
      <div>
        <Row>
          <Col sm={12}>
            <div style={{ fontWeight: "bold" }}><span style={{ color: "red" }}>* </span>{category.column_color}</div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Well>
              {
                enableEdit ?
                  <ChromePicker
                    color={color_value}
                    onChangeComplete={this.handleChangeColor}
                    disableAlpha={true}
                  />
                  : <ReadOnlyField fieldValue={color_value} />
              }
            </Well>
          </Col>
        </Row>
      </div>
    )
  }

  renderFilePropertyColumn() {

    const { category, fileproperty_data, fileproperty_option, enableEdit } = this.state

    return (
      <div>
        <Row>
          <Col sm={12}>
            <div style={{ fontWeight: "bold" }}><span style={{ color: "red" }}>* </span>{category.column_parent}</div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Well>
              <Select
                disabled={!enableEdit}
                value={fileproperty_option}
                placeholder="請選擇"
                options={fileproperty_data}
                onChange={this.onChangeFilePropertyValue}
              />
            </Well>
          </Col>
        </Row>
      </div>
    )
  }

  render() {

    const { route } = this.props;
    const { enableEdit, showErrorMsg, name_value, category } = this.state

    let title = '新' + category.column_name
    if (route.type === 'edit') {
      title = enableEdit === false ? '檢視' + category.column_name : '編輯' + category.column_name
    }

    let render_color_code_column = category.name === 'UserGroup' ? this.renderColorCodeColumn() : ''
    let render_file_property_column = category.name === 'FilePropertyValue' ? this.renderFilePropertyColumn() : ''

    return (
      <div>
        <Modal
          show={true}
          bsSize="large"
          className="div-newsCt"
          keyboard={false}
          backdrop="static"
        // onHide={closeModal}
        >
          <Modal.Header>
            <Modal.Title>{title}</Modal.Title>
            <span className="span-newsModalBtn">
              {this.renderBtns()}
            </span>
          </Modal.Header>
          <Modal.Body>
            {render_file_property_column}
            <Row>
              <Col sm={12}>
                <div style={{ fontWeight: "bold" }}><span style={{ color: "red" }}>* </span>{category.column_name}</div>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <Well>
                  <Row>
                    <Col sm={12}>
                      {
                        enableEdit ?
                          <TextField
                            fieldName='name_value'
                            fieldValue={name_value}
                            onChangeHandler={this.onChangeHandler}
                            showErrorMsg={showErrorMsg}
                          />
                          : <ReadOnlyField fieldValue={name_value} />
                      }
                    </Col>
                  </Row>
                </Well>
              </Col>
            </Row>
            {render_color_code_column}
          </Modal.Body>
          <Modal.Footer>
            {this.renderBtns()}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

AdminCt.prototypes = {
  closeModal: PropTypes.func.isRequired,
}





// WEBPACK FOOTER //
// ./src/salesky/routes/admin/AdminCt.jsx